export type DamageAnnotationType = {
	type: string;
	description: string;
	color: string;
	damageType: number;
};

export type DamageMarker = {
	id: string;
	x: number;
	y: number;
	width: number;
	height: number;
	damageType: number;
	letter: string;
	color: string;
};

export const DAMAGE_ANNOTATION_TYPES: DamageAnnotationType[] = [
	{ type: "A", description: "Amassado", color: "#DD2590", damageType: 3 },
	{ type: "F", description: "Faltando", color: "#CA8504", damageType: 5 },
	{ type: "P", description: "Pique", color: "#444CE7", damageType: 2 },
	{ type: "Q", description: "Quebrado", color: "#181D27", damageType: 4 },
	{ type: "R", description: "Riscado", color: "#0080FE", damageType: 1 },
	{ type: "T", description: "Trincado", color: "#099250", damageType: 6 },
];

export const DEFAULT_DAMAGE_ANNOTATION_TYPE: DamageAnnotationType =
	DAMAGE_ANNOTATION_TYPES[0] ?? {
		type: "A",
		description: "Amassado",
		color: "#DD2590",
		damageType: 3,
	};

export const TAP_SLOP_PX = 10;
export const MIN_FENCE_SIZE_PX = 24;
export const EXPORT_JPEG_QUALITY = 0.85;
export const EXPORT_MAX_LONG_EDGE = 1920;
